import { PropsCell } from '../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  { id: 'type_user', numeric: false, disablePadding: false, label: 'Rol' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'email', numeric: false, disablePadding: false, label: 'Correo' },
  { id: 'phone', numeric: false, disablePadding: false, label: 'Telefono' },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Código',
    center: true,
  },
  { id: 'state', numeric: false, disablePadding: false, label: 'Estatus' },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'name', name: 'Nombre de usuario' },
  { key: 'email', name: 'Correo' },
  { key: 'status_users_id', name: 'Estatus' },
  { key: 'barcode', name: 'Código de barras' },
];

export const valuesEstatus = [
  { key: '1', name: 'Activo' },
  { key: '2', name: 'Inactivo' },
  { key: '3', name: 'Eliminado' },
  { key: '4', name: 'Pendiente' },
];
